import React from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import strikeIcon from "assets/images/strike_icon.svg";
import strike1 from "assets/images/strike_1.svg";
import strike2 from "assets/images/strike_2.svg";
import strike3 from "assets/images/strike_3.svg";
import {gte} from "lodash";
import {StrikeBubble} from "./StrikeBubble";
import {Nullable} from "modules/types";

const Wrapper = styled.div``;

const BubbleWrapper = styled.div`
	display: flex;
	flex-direction: row !important;
	margin: 0 auto 5px;
	> * {
		margin: 2px;
	}
`;

interface ICounterProps {
	strikes: Nullable<number> | undefined;
}

export const StrikeCounter: React.FC<ICounterProps> = ({strikes}) => {
	const {t} = useTranslation();

	return (
		<Wrapper>
			<BubbleWrapper>
				<StrikeBubble
					src={gte(strikes, 1) ? strikeIcon : strike1}
					strikes={strikes}
					index={1}
				/>
				<StrikeBubble
					src={gte(strikes, 2) ? strikeIcon : strike2}
					strikes={strikes}
					index={2}
				/>
				<StrikeBubble
					src={gte(strikes, 3) ? strikeIcon : strike3}
					strikes={strikes}
					index={3}
				/>
			</BubbleWrapper>
			<span>{t("game.stats.strike_counter", "STRIKE COUNTER")}</span>
		</Wrapper>
	);
};
